
import React from 'react';
import { AnimatedSidebarLink } from "@/components/ui/animated-sidebar";

interface SidebarAdminProps {
  adminLinks: {
    label: string;
    href: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];
  open: boolean;
  isAdmin: boolean;
}

export const SidebarAdmin: React.FC<SidebarAdminProps> = ({ adminLinks, open, isAdmin }) => {
  if (!isAdmin || adminLinks.length === 0) return null;

  return (
    <div className="border-t border-gray-800 pt-4 mt-2">
      <div className="flex justify-between items-center mb-4">
        {open && <p className="text-gray-500 text-sm px-2">Admin</p>}
      </div>
      <div className="mt-2 flex flex-col gap-2 px-2">
        {adminLinks.map((link, idx) => (
          <AnimatedSidebarLink key={`admin-${idx}`} link={link} />
        ))}
      </div>
    </div>
  );
};
